import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app';
import * as serviceWorker from './serviceWorker';

import { ThemeProvider,createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
//import * as PXBThemes from '@pxblue/themes/react';
import * as BLIThemes from '@brightlayer-ui/react-themes';
import { StyledEngineProvider } from '@mui/material/styles';

import { ConnectedRouter as Router } from 'connected-react-router';
import { history, configureStore } from './store/store';

import { Provider } from 'react-redux';
import * as ApiRequests from './api/requests';
import { AuthContextProvider, combineDuplicateRequests } from './components/AuthContextProvider';

import './data/translations/i18n';
import '@brightlayer-ui/react-themes/open-sans';

// Patch to have reaquired props optional so that types/react v17/18 mismatch issue is resolved. 
// This would need to be removed once React 18 update is done.
declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace React {
      // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
      interface DOMAttributes<T> {
        onResize?: ReactEventHandler<T> | undefined;
        onResizeCapture?: ReactEventHandler<T> | undefined;
        nonce?: string | undefined;
      }
    }
  }
  
// declare module '@mui/styles/defaultTheme' {
//   //eslint-disable-next-line @typescript-eslint/no-empty-interface
//   type DefaultTheme & Theme 
// }


const refreshTokenFn = combineDuplicateRequests(ApiRequests.refresh);

//const theme = createMuiTheme();



export const buildRootElement = (opts?: {
    numberOfSecondsBeforeExpirationToRefreshToken?: number;
    checkTokenExpirationFrequencyMs?: number;
}): JSX.Element => {
    const numberOfSecondsBeforeExpirationToRefreshToken =
        (opts && opts.numberOfSecondsBeforeExpirationToRefreshToken) || 60 * 4; // 4 minutes before expiration by default

    const checkTokenExpirationFrequencyMs = (opts && opts.checkTokenExpirationFrequencyMs) || undefined;

    return (
        <StyledEngineProvider injectFirst>
        <ThemeProvider theme={createTheme(BLIThemes.blue)}>
            <Provider store={configureStore()}>
                <CssBaseline />
                <Router history={history}>
                    <AuthContextProvider
                        refreshTokenFn={refreshTokenFn}
                        numberOfSecondsBeforeExpirationToRefreshToken={numberOfSecondsBeforeExpirationToRefreshToken}
                        checkTokenExpirationFrequencyMs={checkTokenExpirationFrequencyMs}
                    >
                        <App />
                    </AuthContextProvider>
                </Router>
            </Provider>
        </ThemeProvider>
        </StyledEngineProvider>
    );
};

if (process.env.NODE_ENV !== 'test') {
    ReactDOM.render(buildRootElement(), document.getElementById('root'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
}
